/* Kendo grid command cell (edit/delete/cancel buttons) */

import { GridCell } from '@progress/kendo-react-grid';
import * as React from 'react';
import { Button, ButtonToolbar } from 'react-bootstrap';

import { Formatters } from '../common/formatters';

export default function EditGridCommandCell(
    handleEnterEdit: any,
    handleRemove: any,
    handleSave: any,
    handleCreate: any,
    handleCancel: any,
    handleEnterDetails: any,
    showDetails: any,
    showDelete: any,
    canSave: any,
    recordEditingField: string,
    recordNewItemField: string,
    appText: any) {
        return class extends GridCell {
            public render() {
                const { dataItem, ...rest } = this.props;

                let buttonProps = {
                    bsSize: 'xs'
                };

                const isEditing = Formatters.getBool(dataItem, recordEditingField);
                const isNewItem = Formatters.getBool(dataItem, recordNewItemField);
                const enableSaveButton = canSave(dataItem);
                const showDetailsButton = showDetails(dataItem);
                const showDeleteButton = showDelete(dataItem);

                // console.log(`EditGridCommandCell render enableSaveButton ${enableSaveButton}`, { dataItem });

                let result = (
                    <td>
                        <ButtonToolbar>
                            <Button
                                {...buttonProps}
                                bsStyle="info"
                                onClick={(e) => handleEnterEdit(dataItem)}
                            >
                                <i className="fa fa-pencil" /> <span>{appText('app.common.buttons.edit', false)}</span>
                            </Button>

                            {(showDetailsButton) ? (
                                <Button
                                    {...buttonProps}
                                    bsStyle="warning"
                                    onClick={(e) => handleEnterDetails(dataItem)}
                                >
                                    <i className="fa fa-gear" /> <span>{appText('app.common.buttons.details', false)}</span>
                                </Button>) : (<div />)}

                            {(showDeleteButton) ? (
                                <Button
                                    {...buttonProps}
                                    bsStyle="danger"
                                    disabled={!showDeleteButton}
                                    onClick={(e) => handleRemove(e, dataItem)}
                                >
                                    <i className="fa fa-trash-o" /> <span>{appText('app.common.buttons.delete', false)}</span>
                                </Button>) : (<div />)}
                        </ButtonToolbar>
                    </td>);

                if (isEditing) {
                    let buttonSave = (isNewItem) ? (
                        <Button
                            {...buttonProps}
                                bsStyle={(enableSaveButton) ? 'success' : 'default'}
                                disabled={!enableSaveButton}
                                onClick={(e) => handleCreate(dataItem)}
                            >
                                <i className="glyphicon glyphicon-plus" /> <span>{appText('app.common.buttons.add', false)}</span>
                        </Button>
                    ) : (
                        <Button
                            {...buttonProps}
                            bsStyle={(enableSaveButton) ? 'success' : 'default'}
                            disabled={!enableSaveButton}
                            onClick={(e) => handleSave(dataItem)}
                        >
                            <i className="fa fa-floppy-o" /> <span>{appText('app.common.buttons.update', false)}</span>
                        </Button>);

                    result = (
                        <td>
                            <ButtonToolbar>
                                {buttonSave}
                                <Button
                                    {...buttonProps}
                                    bsStyle="warning"
                                    onClick={(e) => handleCancel(dataItem)}
                                >
                                    <i className="fa fa-times-circle-o" /> <span>{appText('app.common.buttons.cancel', false)}</span>
                                </Button>
                            </ButtonToolbar>
                        </td>);
                }

                return result;
            }
        };
}



// WEBPACK FOOTER //
// ./src/lookup-tables/edit-grid-command-cell.tsx